// @flow
import apiRequest from '../../stores/ApiService';
import apiConfig from '../../config';

const getUser = (baseApiUrl: string) =>
  apiRequest({
    method: 'GET',
    url: `${baseApiUrl}/${apiConfig.urls.userConfiguration}`,
  }).then((response) => response.json());

export default {
  getUser,
};
